<template>
  <div>
    <el-upload
      v-loading="isRequestingUsersBulkUpload"
      :limit="1"
      :http-request="loadFile"
      :before-remove="beforeRemove"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :accept="acceptedFile"
      action=""
    >
      <el-button class="upload-button">
        {{ $t('admin.uploadFileButton') }}
      </el-button>
      <div class="el-upload__tip">
        {{ $t('uploadUsers.uploadHint') }}
      </div>
    </el-upload>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import csvtojson from 'csvtojson';

const mapUser = (user) => ({
  email: user.Email,
  name: user.Name,
});

export default {
  name: 'UserFileUploader',
  props: {
    acceptedFile: {
      type: String,
      required: true,
    },
    officeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fileList: [],
      loading: false,
    };
  },
  computed: {
    ...mapState('offices', { offices: (state) => state.offices }),
    ...mapState('user', {
      isRequestingUsersBulkUpload: (state) => state.isRequestingUsersBulkUpload,
      requestUsersBulkUploadSuccess: (state) => state.requestUsersBulkUploadSuccess,
    }),
    selectedOffice() {
      return this.offices.find((office) => office.id === this.officeId);
    },
  },
  watch: {
    requestUsersBulkUploadSuccess() {
      if (this.requestUsersBulkUploadSuccess) {
        this.$message.success(this.$t('admin.menuParserMessages.successUpload'));
      }
    },
    requestUsersBulkUploadFailure() {
      if (this.requestUsersBulkUploadFailure) {
        this.$message.error(this.$t('admin.menuParserMessages.errorUpload'));
        this.fileList = [];
      }
    },
  },
  methods: {
    handleExceed() {
      this.$message.warning(this.$t('admin.exceededFileLimitMessage'));
    },
    beforeRemove() {
      return this.$confirm(this.$t('admin.beforeRemoveFileMessage'));
    },
    async loadFile(fileData) {
      const fileReader = new FileReader();
      fileReader.onload = async () => {
        try {
          const officeName = this.selectedOffice.name;
          const fileContent = fileReader.result;
          const jsonArray = await csvtojson().fromString(fileContent);
          const users = jsonArray
            .filter((item) => officeName.startsWith(item.Location))
            .map(mapUser);
          if (users.length > 0) this.bulkCreateUsers(users);
        } catch (errorFromMenuParser) {
          this.$message.error(this.$t(errorFromMenuParser.message));
          this.fileList = [];
        }
      };
      fileReader.readAsText(fileData.file);
    },
    ...mapActions('user', { bulkCreateUsers: 'bulkCreateUsers' }),
  },
};
</script>
<style scoped lang="scss">
@import '../scss/variables';

.el-message-box {
  height: 180px;
  &__message p {
    font-family: 'Avenir';
  }
}

.upload-button {
  width: 105px;
}

/deep/ .el-upload {
  &__tip {
    text-align: center;
    font-size: $label-description-text-size;
  }
}

/deep/ .el-upload-list {
  &--text {
    text-align: left;
  }
  /deep/ .el-icon-close-tip {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserFileUploader.vue